import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	workItemsFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	beta: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	findingResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hideSuggestions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showNumResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewNumSuggestions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inactiveMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noResultsFound: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	anErrorOccurred: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchAgain: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hideError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	workItemsFound: {
		id: 'proactive-container.work-items-found',
		defaultMessage: '{itemCount} items found',
		description: 'Message inside Badge saying how many work items found',
	},
	beta: {
		id: 'proactive-container.beta',
		defaultMessage: 'BETA',
		description: 'Lozenge to indicate that feature is in beta phase',
	},
	findingResults: {
		id: 'proactive-container.finding-results',
		defaultMessage: 'Finding results',
		description: 'Text to indicate that the AI is finding results',
	},
	viewItems: {
		id: 'proactive-container.view-items',
		defaultMessage: 'View items',
		description: 'Button text to view suggested items',
	},
	hideSuggestions: {
		id: 'proactive-container.hide-suggestions',
		defaultMessage: 'Hide suggestions',
		description: 'Button text to hide suggested items',
	},
	showNumResults: {
		id: 'proactive-container.show-results',
		defaultMessage: 'Show {numResults} {numResults, plural, one {result} other {results}}',
		description: 'Button text to show the number of results',
	},
	viewNumSuggestions: {
		id: 'proactive-container.view-suggestions',
		defaultMessage: 'View {numResults} {numResults, plural, one {suggestion} other {suggestions}}',
		description: 'Button text to view the number of suggestions',
	},
	inactiveMessage: {
		id: 'proactive-container.inactive-message',
		defaultMessage: 'Search',
		description: 'Button text to search for items',
	},
	noResultsFound: {
		id: 'proactive-container.no-results-found',
		defaultMessage: 'No results found.',
		description: 'Message to indicate that no results were found',
	},
	anErrorOccurred: {
		id: 'proactive-container.an-error-occurred',
		defaultMessage: 'An error occurred.',
		description: 'Message to indicate that an error occurred',
	},
	viewError: {
		id: 'proactive-container.view-error',
		defaultMessage: 'View error',
		description: 'Button text to view the error',
	},
	searchAgain: {
		id: 'proactive-container.search-again',
		defaultMessage: 'Search again',
		description: 'Button text to retry the action',
	},
	hideError: {
		id: 'proactive-container.hide-error',
		defaultMessage: 'Hide error',
		description: 'Button text to hide the error details',
	},
});
export default messages;
